import React from 'react';
import MDTypography from '../../../shared/atoms/MDTypography';

interface RouteLoadingTextProps {
  message?: string;
  variant?: 'h6' | 'body1' | 'body2';
}

const RouteLoadingText: React.FC<RouteLoadingTextProps> = ({ 
  message = 'Loading...', 
  variant = 'h6' 
}) => {
  return (
    <MDTypography 
      variant={variant} 
      color="secondary"
      textAlign="center"
    >
      {message}
    </MDTypography>
  );
};

export default RouteLoadingText;